import React, { useEffect } from 'react';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/AppState/Common';
import { GamStopSection } from './GamStop';
import { GamstopTabState } from './GamstopTab.state';
import { LoadingV2 } from 'src/components/Loading/LoadingV2';
import { Button } from 'src/domains/common/components/button/button';
import { ErrorMessage, GamstopTabContainer, Header, PageHeader } from './GamstopTab.style';

export const GamstopTab = observer('GamstopTab', (): React.ReactElement => {
    const common = useCommon();
    const state = GamstopTabState.get(common);
    const isFinished = !state.isLoading && !state.hasError;

    useEffect(() => {
        const intervalId = setInterval(() => {
            state.refresh().catch((error) => {
                console.error('GamstopTab refresh error', error);
            });
        }, 10000);

        return (): void => {
            clearInterval(intervalId);
        };
    }, [state]);

    if (state.isLoading) {
        return (
            <LoadingV2
                dataTest='gamstop-tab-loading'
                title='Loading...'
            />
        );
    }

    return (
        <GamstopTabContainer data-test='gamstop-account-not-longer-blocked'>
            <PageHeader>
                <Header data-test='main-header'>GamStop</Header>
                <Button
                    variant='link'
                    size='sm'
                    dataTest='refresh-button'
                    onClick={(): void => {
                        state.refresh().catch((error) => {
                            console.error('GamstopTab refresh error', error);
                        });
                    }}
                >
                    Refresh
                </Button>
            </PageHeader>

            {state.hasError ? <ErrorMessage>Error during fetching data</ErrorMessage> : null}

            <GamStopSection
                type='your'
                header='Assigned To You'
                dataTest='gamstop-account-not-longer-blocked-assigned-to-you'
                notifications={state.yourNotifications}
                state={state}
                isFinished={isFinished}
            />
            <GamStopSection
                type='none'
                header='Pending Requests'
                dataTest='gamstop-account-not-longer-blocked-pending-requests'
                notifications={state.noneNotifications}
                state={state}
                isFinished={isFinished}
            />
            <GamStopSection
                type='other'
                header='Assigned To Others'
                dataTest='gamstop-account-not-longer-blocked-assigned-to-others'
                notifications={state.otherNotifications}
                state={state}
                isFinished={isFinished}
            />
        </GamstopTabContainer>
    );
});
